module.exports = __webpack_public_path__ + "static/media/fivefu-enter.0acced64.png";